import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {ExamFormModel} from "../../../api/model/exam-form.model";
import {AbstractDataServiceV2} from "../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {CustomizeHttpUrlGenerator} from "../../../../../store/core/url/customizeHttpUrlGenerator";
import {ExamFormConverter} from "../../../api/converter/examForm.converter";

@Injectable()
export class ExamFormDataService extends AbstractDataServiceV2<ExamFormModel, ExamFormConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig, converter: ExamFormConverter) {
        super('ExamForm', http, httpUrlGenerator, logger, config, converter);
    }
}
